import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'ngx-elvis-ds';
import { CartService } from 'src/app/services/cart.service';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'elv-pop-qty-select',
  templateUrl: './pop-qty-select.component.html',
  styleUrls: ['./pop-qty-select.component.scss'],
})
export class PopQtySelectComponent implements OnInit {

  constructor(
    public themeSvc: ThemeService,
    public cartSvc: CartService,
    private popoverCtrl: PopoverController
  ) { }

  ngOnInit() {}

  onDismiss() {
    this.popoverCtrl.dismiss();
  }
}
